import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import ContentBlock from '@bitcoin-portal/bitcoincom-pkg-components/dist/ContentBlock';
import Image from '@bitcoin-portal/bitcoincom-pkg-components/dist/Image';

export const StyledContentBlock = styled(ContentBlock)`
  ${media.md`
    margin-bottom: 100px;
  `}
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  overflow: visible;
  width: 100%;

  & > span {
    display: inline-flex !important;
    justify-content: center;
  }

  ${media.md`
    justify-content: flex-start;
    max-height: 260px;
  `}

  ${media.xl`
    max-height: 480px;
  `}
`;

export const StyledImage = styled(Image)`
  filter: drop-shadow(0px 20px 51px rgba(39, 147, 255, 0.6));
  margin-bottom: 40px;
  width: 231px;
  height: 230px;

  ${media.md`
    filter: drop-shadow(0px 28px 71px rgba(39, 147, 255, 0.6));
    margin-bottom: 0;
    width: 323px;
    height: 321px;
  `}

  ${media.xl`
    filter: drop-shadow(0px 44px 110px rgba(39, 147, 255, 0.6));
    width: 587px;
    height: 584px;
  `}
`;
